import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/company/clinic/:id',
  title: 'Editar Clinica',
  endpoint: '/app/company',
}
